import {
  Proveedor
} from '../../models/proveedor.model';
import {
  FacturaPendiente,
  TipoGasto,
  PagoProveedor,
  CuentaProveedorResumen
} from '../../models/compra.model';
import { MedioPago, CuentaFondo } from '../../models/venta.model';
import { Cheque, CuentaBancaria } from '../../models/cheque.model';

// ══════════════════ Proveedores ══════════════════

export const MOCK_PROVEEDORES: Proveedor[] = [
  {
    id: 1, codigo: 'PROV-001', razon_social: 'Distribuidora San Juan SRL',
    cuit: '30-71234567-9', condicion_iva: 'responsable_inscripto',
    direccion: 'Av. San Martín 1250, San Juan', ciudad_id: null, ciudad_legacy: 'San Juan',
    telefono: '0264-4201234', email: 'contacto@disanj.com.ar', contacto: 'Carlos Pérez',
    observaciones: null, activo: true, codigo_legacy: null
  },
  {
    id: 2, codigo: 'PROV-002', razon_social: 'IMPORTADORA DEL SUR',
    cuit: '30-79876543-1', condicion_iva: 'responsable_inscripto',
    direccion: 'Belgrano 880, Mendoza', ciudad_id: null, ciudad_legacy: 'Mendoza',
    telefono: '0261-4501111', email: 'ventas@importsur.com.ar', contacto: 'María López',
    observaciones: 'Pedido mínimo $50.000', activo: true, codigo_legacy: null
  },
  {
    id: 3, codigo: 'PROV-003', razon_social: 'Mayorista Norte SA',
    cuit: '30-75551234-5', condicion_iva: 'responsable_inscripto',
    direccion: 'Ruta 9 km 520, Santa Fe', ciudad_id: null, ciudad_legacy: 'Santa Fe',
    telefono: '0342-4509999', email: 'pedidos@maynorte.com.ar', contacto: 'Roberto Gómez',
    observaciones: null, activo: true, codigo_legacy: null
  },
];

// ══════════════════ Cuentas de Fondos ══════════════════

export const MOCK_CUENTAS: CuentaFondo[] = [
  { id: 1, nombre: 'Caja General', tipo: 'caja', sucursal_id: 1, activo: true, saldo: 150000 },
  { id: 2, nombre: 'Banco Nación - Cta Cte', tipo: 'banco', sucursal_id: 1, activo: true, saldo: 450000 },
  { id: 3, nombre: 'Banco Galicia - Caja Ahorro', tipo: 'banco', sucursal_id: 1, activo: true, saldo: 280000 },
];

// ══════════════════ Medios de Pago ══════════════════

export const MOCK_MEDIOS_PAGO: MedioPago[] = [
  { id: 1, nombre: 'Efectivo', tipo: 'contado', cuenta_fondo_default_id: 1, activo: true },
  { id: 2, nombre: 'Cheque', tipo: 'valor', cuenta_fondo_default_id: null, activo: true },
  { id: 3, nombre: 'Transferencia', tipo: 'digital', cuenta_fondo_default_id: 2, activo: true },
  { id: 4, nombre: 'Depósito', tipo: 'digital', cuenta_fondo_default_id: 2, activo: true },
  { id: 5, nombre: 'Nota de Crédito', tipo: 'contado', cuenta_fondo_default_id: null, activo: true },
];

// ══════════════════ Facturas Pendientes (por proveedor) ══════════════════

export const MOCK_FACTURAS_PENDIENTES: Record<number, FacturaPendiente[]> = {
  1: [
    { id: 101, tipo_comprobante: 'factura_a', punto_venta_numero: '0001-00000101', fecha: '2026-06-15', total: 45000, saldo: 45000, tipogasto_id: 1, tipogasto: 'Mercadería' },
    { id: 102, tipo_comprobante: 'factura_b', punto_venta_numero: '0001-00000102', fecha: '2026-06-20', total: 12500, saldo: 12500, tipogasto_id: null, tipogasto: null },
    { id: 103, tipo_comprobante: 'factura_a', punto_venta_numero: '0001-00000103', fecha: '2026-07-01', total: 89000, saldo: 89000, tipogasto_id: 2, tipogasto: 'Servicios' },
  ],
  2: [
    { id: 201, tipo_comprobante: 'factura_a', punto_venta_numero: '0002-00000201', fecha: '2026-06-10', total: 125000, saldo: 125000, tipogasto_id: 1, tipogasto: 'Mercadería' },
    { id: 202, tipo_comprobante: 'factura_c', punto_venta_numero: '0002-00000202', fecha: '2026-07-05', total: 33000, saldo: 33000, tipogasto_id: null, tipogasto: null },
  ],
  3: [
    { id: 301, tipo_comprobante: 'factura_a', punto_venta_numero: '0003-00000301', fecha: '2026-05-20', total: 67500, saldo: 67500, tipogasto_id: 3, tipogasto: 'Alquiler' },
    { id: 302, tipo_comprobante: 'factura_a', punto_venta_numero: '0003-00000302', fecha: '2026-06-28', total: 41000, saldo: 41000, tipogasto_id: null, tipogasto: null },
    { id: 303, tipo_comprobante: 'nota_debito', punto_venta_numero: '0003-00000303', fecha: '2026-07-10', total: 8200, saldo: 8200, tipogasto_id: 4, tipogasto: 'Impuestos' },
  ],
};

// ══════════════════ Cheques en Cartera ══════════════════

export const MOCK_CHEQUES_CARTERA: Cheque[] = [
  {
    id: 201, tipo: 'tercero', numero: '12345678', banco_id: 1,
    banco: { id: 1, nombre: 'Nación' }, importe: 25000,
    fecha_emision: '2026-07-01', fecha_cobro: '2026-08-01',
    firmante: 'Juan García', cuit_firmante: '20-12345678-9',
    cliente_id: null, cuenta_bancaria_id: null, estado: 'en_cartera',
    origen_tipo: null, origen_id: null, observaciones: null
  },
  {
    id: 202, tipo: 'tercero', numero: '87654321', banco_id: 2,
    banco: { id: 2, nombre: 'Galicia' }, importe: 18000,
    fecha_emision: '2026-07-05', fecha_cobro: '2026-08-15',
    firmante: 'Ana Martínez', cuit_firmante: '27-98765432-0',
    cliente_id: null, cuenta_bancaria_id: null, estado: 'en_cartera',
    origen_tipo: null, origen_id: null, observaciones: null
  },
];

// ══════════════════ Cuentas Bancarias (para cheques propios) ══════════════════

export const MOCK_CUENTAS_BANCARIAS: CuentaBancaria[] = [
  { id: 1, banco_id: 1, banco: { id: 1, nombre: 'Nación' }, nombre: 'Cta Cte', numero: '12345678', cbu: null, titular: 'Mi Empresa SRL', activo: true },
  { id: 2, banco_id: 2, banco: { id: 2, nombre: 'Galicia' }, nombre: 'Cta Corriente', numero: '87654321', cbu: null, titular: 'Mi Empresa SRL', activo: true },
];

// ══════════════════ Tipos de Gasto ══════════════════

export const MOCK_TIPOS_GASTO: TipoGasto[] = [
  { id: 1, nombre: 'Mercadería', activo: true },
  { id: 2, nombre: 'Servicios', activo: true },
  { id: 3, nombre: 'Alquiler', activo: true },
  { id: 4, nombre: 'Impuestos', activo: true },
];

// ══════════════════ Pagos Existentes (histórico) ══════════════════

export const MOCK_PAGOS: PagoProveedor[] = [
  {
    id: 1, proveedor_id: 1, numero: 'OP-0001', fecha: '2026-07-10', total: 57500,
    estado: 'confirmada', fecha_anulacion: null, motivo_anulacion: null, observaciones: 'Pago factura junio',
    proveedor: { id: 1, codigo: 'PROV-001', razon_social: 'Distribuidora San Juan SRL' },
    usuario: { id: 1, nombre: 'Admin', apellido: '' },
    medios: [
      { id: 1, medio_pago_id: 1, importe: 57500, cuenta_fondo_id: 1, nota_credito_id: null, referencia: null }
    ],
    imputaciones: [
      { id: 1, compra_id: 101, importe: 45000, compra: { id: 101, punto_venta_numero: '0001-00000101', fecha: '2026-06-15', total: 45000, tipo_comprobante: 'factura_a', tipo_gasto: { id: 1, nombre: 'Mercadería' } } },
      { id: 2, compra_id: 102, importe: 12500, compra: { id: 102, punto_venta_numero: '0001-00000102', fecha: '2026-06-20', total: 12500, tipo_comprobante: 'factura_b', tipo_gasto: null } },
    ]
  },
  {
    id: 2, proveedor_id: 2, numero: 'OP-0002', fecha: '2026-07-15', total: 80000,
    estado: 'confirmada', fecha_anulacion: null, motivo_anulacion: null, observaciones: null,
    proveedor: { id: 2, codigo: 'PROV-002', razon_social: 'IMPORTADORA DEL SUR' },
    usuario: { id: 1, nombre: 'Admin', apellido: '' },
    medios: [
      { id: 2, medio_pago_id: 3, importe: 80000, cuenta_fondo_id: 2, nota_credito_id: null, referencia: 'TRANSF-001234' }
    ],
    imputaciones: [
      { id: 3, compra_id: 201, importe: 80000, compra: { id: 201, punto_venta_numero: '0002-00000201', fecha: '2026-06-10', total: 125000, tipo_comprobante: 'factura_a', tipo_gasto: { id: 1, nombre: 'Mercadería' } } },
    ]
  },
];

// ══════════════════ Estado mutable ══════════════════

let nextPagoId = 3;
let nextNumero = 3;

export function getNextPagoId(): number { return nextPagoId++; }
export function getNextNumero(): string { return `OP-${String(nextNumero++).padStart(4, '0')}`; }

export function agregarPagoMock(pago: PagoProveedor): void {
  MOCK_PAGOS.unshift(pago);
}

export function eliminarTipoGastoMock(id: number): void {
  const idx = MOCK_TIPOS_GASTO.findIndex(t => t.id === id);
  if (idx >= 0) MOCK_TIPOS_GASTO.splice(idx, 1);
}

export function crearTipoGastoMock(nombre: string): TipoGasto {
  const id = Math.max(...MOCK_TIPOS_GASTO.map(t => t.id)) + 1;
  const nuevo = { id, nombre, activo: true };
  MOCK_TIPOS_GASTO.push(nuevo);
  return nuevo;
}

// ══════════════════ Helpers para respuestas paginadas ══════════════════

export function paginar<T>(data: T[], perPage: number = 15, page: number = 1) {
  const total = data.length;
  const lastPage = Math.ceil(total / perPage) || 1;
  const from = (page - 1) * perPage;
  const to = Math.min(from + perPage, total);
  return {
    current_page: page,
    data: data.slice(from, to),
    first_page_url: '',
    from: from + 1,
    last_page: lastPage,
    last_page_url: '',
    next_page_url: page < lastPage ? '' : null,
    path: '',
    per_page: perPage,
    prev_page_url: page > 1 ? '' : null,
    to,
    total,
  };
}

export function response<T>(data: T) {
  return { success: true, data, message: null };
}

export function paginatedResponse<T>(data: T[], perPage: number = 15, page: number = 1) {
  return { success: true, data: paginar(data, perPage, page), message: null };
}
